import React from 'react'
import { useStore } from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Store/useStore'

/**
 * Overrides src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Components/FilterTag.js
 * The override is registered at /overwriteMapping.js and replaces the original file completely
 */
const FilterTag = ({ filter }) => {
    const setFilterState = useStore((state) => state.setFilterState)
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const showFilterCount = useStore((state) => state.showFilterCount)

    const checked = activeFilterTagUids.some(filterTags => filterTags.filterUid === filter.uid)

    const handleChange = () => {
        setFilterState(filter.uid, !checked)
    }

    const getFilterCount = () => {
        if (!showFilterCount) {
            return null
        }

        return <span className="journal-list__filter-item-count">({filter.count})</span>
    }

    return (
        <button className="journal-list__filter-item" onClick={handleChange} aria-pressed={checked}>
            <span className="journal-list__filter-item-name">{filter.name}</span>
            {getFilterCount()}
        </button>
    )
}

export default FilterTag
